import { useEffect, useState } from "react";
import { Divider, Drawer, Dropdown, Space } from "antd";
import { Link } from "react-router-dom";
import RegisterModal from "../Modals/Register";
import "./style.css";
import { FiMenu, FiUser } from "react-icons/fi";
import axios from "axios";
import { api } from "../../api/url";

const Header = () => {
  const [open, setOpen] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [opendropdown, setOpendropdown] = useState(false);
  const [companies, changeCompanies] = useState([]);
  const [companiesDropdown, changeCompaniesDropdown] = useState([]);

  // ------------------- Get Companies
  const GetCompanies = async () => {
    await axios({
      url: api + "appointment/company/getdropdown",
      method: "get",
    })
      .then((res) => {
        changeCompanies(res.data.data);
        // changeSpecialities(res.data.data);
      })
      .catch((err) => {
        console.log("err", err);
        // setLoading(false);
      });
  };

  useEffect(() => {
    GetCompanies();
  }, []);

  

  

  return (
    <div className="header">
      <nav className="container header-container">
        <button
          onClick={() => setOpenDrawer(true)}
          className="headr-responsive-menu"
        >
          <FiMenu />
        </button>

        <a href="/" className="header-logo">
          <img className="" src={require("../../assets/images/logo.png")} />
        </a>

        <ul className="header-links">
          <li className="">
            <Link to="/">صفحه اصلی</Link>
          </li>

          <li className=" ">
            <Dropdown
              menu={{
                items: companies.map((item) => {
                  return {
                    label: (
                      <a
                        href={"/department/" + item.id}
                        className="header-dropdown-item"
                      >
                        {item.name}
                      </a>
                    ),
                    key: item.id,
                  };
                }),
                onClick: setOpendropdown,
              }}
              overlayStyle={{ cursor: "pointer" }}
              onOpenChange={setOpendropdown}
              open={opendropdown}
            >
              <a
                style={{ cursor: "pointer", height: "100%" }}
                onClick={(e) => e.preventDefault()}
              >
                مراکز
              </a>
            </Dropdown>
          </li>

          <li className=" ">
            <Link to={"/doctors"}>پزشکان</Link>
          </li>
          <li className=" ">
            <Link to={"/aboutus"}>درباره‌ما</Link>
          </li>

          <li className=" ">
            <Link to={"/contactus"}>تماس‌با‌ما</Link>
          </li>
        </ul>
        {localStorage.getItem("token") ? (
          <Link to={"/profile"} className="login-btn header-profile-btn">
            <FiUser />
            <span>{localStorage.getItem("cellphone")}</span>
          </Link>
        ) : (
          <button onClick={() => setOpen(true)} className="login-btn ">
            ورود | ثبت نام
          </button>
        )}
      </nav>
      <RegisterModal open={open} setOpen={setOpen} />

      <Drawer
        width={"75%"}
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        placement="right"
        styles={{
          header: {
            display: "none",
          },
        }}
      >
        <DrawerContent setOpenDrawer={setOpenDrawer} />
      </Drawer>
    </div>
  );
};

export default Header;

const links = [
  { route: "/", title: "صفحه اصلی" },
  { route: "/doctors", title: "پزشکان" },
  { route: "/aboutus", title: "درباره‌ما" },
  { route: "/contactus", title: "تماس‌با‌ما" },
];
const DrawerContent = (props) => {
  const onClick = () => {
    props.setOpenDrawer(false);
  };

  return (
    <div className="drawer-container">
      <img className="" src={require("../../assets/images/logo-image.png")} />
      <img
        className="logo-text"
        src={require("../../assets/images/logo-type.png")}
      />
      {/* <Divider /> */}

      {links.map((item, index) => (
        <Link
          className="drawer-link"
          onClick={() => onClick()}
          to={item.route}
          key={"drawerItem" + index}
        >
          {item.title}
        </Link>
      ))}

      <p className="drawer-footer">ورژن ۱.۲</p>
    </div>
  );
};
